import React, { Fragment } from 'react'
import ReactMarkdown from 'react-markdown'
import { Container, Row, Col } from 'reactstrap'

import terms from 'raw!./terms.md'
import SectionMain from '~/components/pages/Section'
import Helmet from 'react-helmet'

const TermsPage = () => (
  <Fragment>
    <Helmet>
      <title>Botpress – Terms and conditions</title>
    </Helmet>
    <SectionMain backgroundColor="light">
      <Container>
        <Row>
          <Col md={{ size: 8, offset: 2 }} className="terms-and-condition">
            <ReactMarkdown source={terms} />
          </Col>
        </Row>
      </Container>
    </SectionMain>
  </Fragment>
)

export default TermsPage



// WEBPACK FOOTER //
// ./src/pages/company/terms.js